import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormArray } from '@angular/forms';
import { delay } from '@core/utils/delay';

@Component({
  selector: 'verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerificationCodeComponent  implements OnInit {
  @Input()
  public verificationCodeForm: FormArray;

  @Output()
  public next: EventEmitter<void>;

  constructor() {
    this.next = new EventEmitter<void>();
  }

  public async onKeyDown(event: KeyboardEvent, index: number): Promise<void> {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').substring(0, 6);

    if (['Backspace'].includes(event.key)) {
      const newValue = input.value.substring(0, input.value.length - 1);
      this.verificationCodeForm.controls[index].setValue(newValue || null);
      if (input.value.length === 0) {
        this.setFocusOnElement(index - 1);
      }
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    await delay(0);


    if (['ArrowLeft'].includes(event.key)) {
      this.setFocusOnElement(index - 1);
      return;
    }

    if (['ArrowRight'].includes(event.key)) {
      this.setFocusOnElement(index + 1);
      return;
    }

    if (['Enter'].includes(event.key) && this.verificationCodeForm.valid) {
      this.next.emit();
      return;
    }

    if (input.value.length === 1) {
      this.setFocusOnElement(index + 1);
      return;
    }

    if (input.value.length === 6) {
      this.verificationCodeForm.setValue(input.value.split(''));
      this.setFocusOnElement(5);
      this.next.emit();
      return;
    }

    const value = input.value.slice(0, 6).split('');
    do {
      this.setFocusOnElement(index);
      this.verificationCodeForm.controls[index++].setValue(value.shift());
    } while (value.length && index < 6);


  }

  private setFocusOnElement(index: number): void {
    const elements = document.getElementsByName(`verification-code-${index}`);
    if (elements && elements.length) {
      elements[0].focus();
    }
  }

  async ngOnInit(): Promise<void> {
    await delay(0);

    this.setFocusOnElement(0);
  }
}
